import { cx } from '@/lib/cx';
import { DASH } from '@/lib/format';
import s from './Meters.module.css';

/**
 * Match % — "how much of your strategy's conditions are met right now". Brand blue, never
 * green/red: it is not a bullish or bearish signal (web_app_design.md §18). Glows at 100%, the
 * one place the app says "this is live".
 */
export function MatchBar({
  percent,
  size = 'md',
  showValue = true,
}: {
  percent: number | null | undefined;
  size?: 'sm' | 'md' | 'lg';
  showValue?: boolean;
}) {
  const known = typeof percent === 'number' && Number.isFinite(percent);
  const p = known ? Math.max(0, Math.min(100, percent)) : 0;
  const full = known && p >= 100;
  return (
    <div className={cx(s.match, s[size])} title={known ? `${Math.round(p)}% of conditions met` : undefined}>
      <div className={s.track}>
        <div className={cx(s.fill, full && s.fullFill, p < 80 && s.dimFill)} style={{ width: `${p}%` }} />
      </div>
      {showValue && (
        <span className={cx(s.value, full && s.fullValue, !known && s.unknown)}>
          {known ? `${Math.round(p)}%` : DASH}
        </span>
      )}
    </div>
  );
}

/** A plain proportion bar (credits used, exit-reason share, progress). */
export function ProgressBar({
  value,
  max = 100,
  tone = 'brand',
  height = 6,
  className,
}: {
  value: number;
  max?: number;
  tone?: 'brand' | 'warn' | 'neg' | 'pos' | 'muted';
  height?: number;
  className?: string;
}) {
  const w = max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0;
  return (
    <div className={cx(s.bar, className)} style={{ height }} role="progressbar" aria-valuenow={value} aria-valuemax={max}>
      <div className={cx(s.barFill, s[`tone_${tone}`])} style={{ width: `${w}%` }} />
    </div>
  );
}
